import React, { useState } from "react";
import LogoComponent from "@global/logo/Logo";
import "./NavigationBar.scss";
import MenuIcon from "@assets/icons/Menu.inline.svg";
import { H3 } from "@global/text/Text.component";
import { navigate } from "gatsby";
import Frame from "@global/frame/Frame";
import { useBreakpoint } from "@helpers/BreakpointHook";

const structure = [
   {
      label: "About Me",
      path: "/about-me"
   },
   {
      label: "Writing",
      path: "/this-space-for-cuorespondence"
   },
];

const NavigationBar = () => {
   const horizontalPadding = useBreakpoint({ mobileSm: 16, tabletSm: 32 });

   return (
      <Frame
         className="navigation-bar"
         layout={{ gap: "auto", align: "center-left", horizontalPadding: horizontalPadding, verticalPadding: 16, width: "fill", maxWidth: 1361 }}
      >
         <LogoArea />
         <NavigationArea />
      </Frame>
   );
}

const LogoArea = () => {
   const gap = useBreakpoint([8, 16, 16]);

   return (
      <Frame className="logo-area" layout={{ gap: gap }} onClick={() => navigate("/")}>
         <LogoComponent />
         <Frame className="title" layout={{ align: "center-left", height: "fill" }}>
            <H3>howel <b>chan</b></H3>
         </Frame>
      </Frame>
   );
}

const NavigationArea = () => {
   const [isMenuActive, setIsMenuActive] = useState(false);
   const onClickMenu = () => setIsMenuActive(!isMenuActive);

   const MobileMenu = () => (
      <React.Fragment>
         <BurgerButton onClick={onClickMenu} />
         {isMenuActive ? <Menu setIsMenuActive={setIsMenuActive} /> : null}
      </React.Fragment>
   );

   return (
      <Frame className="navigation-area" layout={{ gap: 32 }}>
         {useBreakpoint({
            mobileSm: <MobileMenu />,
            tabletSm: <Menu setIsMenuActive={setIsMenuActive} />
         })}
      </Frame>
   );
}

const BurgerButton = ({ onClick }) => (
   <div className="menu-burger" onClick={onClick}>
      <MenuIcon />
   </div>
);

const Menu = ({ setIsMenuActive }) => {
   const layoutMobile = { gap: 32, direction: "vertical", ignore: true, horizontalPadding: 16, verticalPadding: 16 }
   const layoutTablet = { gap: 32 }

   const layout = useBreakpoint({ mobileSm: layoutMobile, tabletSm: layoutTablet });

   const onClickNavItem = (path) => {
      navigate(path);
      setIsMenuActive(false);
   }

   return (
      <Frame className="menu" layout={layout}>
         {structure.map(({ label, path }, index) =>
            <NavItem
               onClick={() => onClickNavItem(path)}
               key={index}
               label={label}
            />
         )}
      </Frame>
   );
}

const NavItem = ({ label, onClick }) => (
   <div className="nav-item" onClick={onClick}>
      <H3>{label}</H3>
   </div>
);

export default NavigationBar;